/**
 * Compact age gate shown over the console (replaces the old full-page lore landing as the gate).
 * Same storage key as before: nt3d_disclaimer_accepted.
 */
import { useState } from 'react';

export default function AgeGate({ onAccept, onReadLore }: { onAccept: () => void; onReadLore: () => void }) {
  const [ok, setOk] = useState(false);
  return (
    <div className="holo-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="nt3d-gate-title">
      <div className="holo-panel holo-gate">
        <div className="ph"><span className="lbl" id="nt3d-gate-title">Before you play</span><span className="holo-demo">● TESTNET DEMO</span></div>
        <p className="gate-lead">THALIA is counting down. Every key adds <b>+30s</b>. When the clock hits zero, the last buyer takes the pot.</p>
        <ul className="gate-list">
          <li><b>Age requirement.</b> You must be 18 or older (or the legal age in your jurisdiction).</li>
          <li><b>High-risk game.</b> This is a testnet demo using <b>test FRAME</b> only. Test tokens have no real value.</li>
          <li><b>$FRAME has not launched.</b> Nobody holds it yet and there is no price.</li>
        </ul>
        <label className="gate-check">
          <input id="nt3d-age-gate" type="checkbox" checked={ok} onChange={e => setOk(e.target.checked)} aria-label="I confirm I am 18 or older and accept the terms" />
          <span>I confirm that I am of legal age, I understand this is a high-risk game, and I accept the terms.</span>
        </label>
        <div className="gate-actions">
          <button type="button" className="holo-btn ghost" onClick={onReadLore}>Read the thesis</button>
          <button
            type="button" className="holo-btn pri" disabled={!ok}
            onClick={() => { try { localStorage.setItem('nt3d_disclaimer_accepted', 'true'); } catch { /* ignore */ } onAccept(); }}
          >
            Enter the console
          </button>
        </div>
      </div>
    </div>
  );
}
